/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { toast } from "react-toastify";

const Application = ({
  handleBack,
  physicalChecked,
  setPhysicalChecked,
  inWordNumber,
  setInWordNumber,
  inWordIdDate,
  setInWordIdDate,
  inWordIdFile,
  setInWordIdFile,
  onlineChecked,
  setOnlineChecked,
  appId,
  setAppId,
  appIdDate,
  setAppIdDate,
  appIdFile,
  setAppIdFile,
  password,
  setPassword,
  userName,
  setUserName,
  email,
  setEmail,
  ePassword,
  setEPassword
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [phyId, setPhyId] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showEpassword, setShowEPassword] = useState(false);

  const projectId = localStorage.getItem("projectId");
  const physicalId = localStorage.getItem("physicalId");

  const validateData = () => {
    let isValid = true;
    const newErrors = {};
  

  
    if (onlineChecked === 1) {
      if (!String(appId).trim()) {
        newErrors.appId = appId;
        isValid = false;
      }
      if (!String(userName).trim()) {
        newErrors.userName = userName;
        isValid = false;
      }
  
      if (!String(password).trim()) {
        newErrors.password = password;
        isValid = false;
      }
  
      if (!String(email).trim()) {
        newErrors.email = email;
        isValid = false;
      }
  
      if (!String(ePassword).trim()) {
        newErrors.ePassword = ePassword;
        isValid = false;
      }
    } else {
      if (!String(inWordNumber).trim()) {
        newErrors.inWordNumber = inWordNumber;
        isValid = false;
      }  
    }

    if (onlineChecked === 1 && physicalChecked == 1) {
      if (!String(inWordNumber).trim()) {
        newErrors.inWordNumber = inWordNumber;
        isValid = false;
      }
      if (!String(appId).trim()) {
        newErrors.appId = appId;
        isValid = false;
      }
      if (!String(userName).trim()) {
        newErrors.userName = userName;
        isValid = false;
      }
  
      if (!String(password).trim()) {
        newErrors.password = password;
        isValid = false;
      }
  
      if (!String(email).trim()) {
        newErrors.email = email;
        isValid = false;
      }
  
      if (!String(ePassword).trim()) {
        newErrors.ePassword = ePassword;
        isValid = false;
      }

    }
  
    setErrors(newErrors);
    return isValid;
  };
  
  const handleCheckboxChange = (e) => {
    setOnlineChecked(e.target.checked ? 1 : 0);
  };

  const handleDeleteInvoice = async (fieldName) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/delete-appfile/${fieldName}/${projectId || state?.projectId}`);
        if (response.status === 200) {
            toast.success(response.data.message);
          // Remove the file from the UI
          if (fieldName === 'inWordIdFile') {
            setInWordIdFile(null);
          } else if (fieldName === 'appIdFile') {
            setAppIdFile(null);
          }
        }
    } catch (error) {
        console.error('Error deleting file:', error);
    }
};

  const handleNext = async () => {
    if (validateData()) {
      try {
        const formData = new FormData();
        formData.append("projectId", projectId || state?.projectId);
        formData.append("userName", userName);
        formData.append("password", password);
        formData.append("email", email);
        formData.append("ePassword", ePassword);
        formData.append("physicalChecked", physicalChecked);
        
        formData.append("onlineChecked", onlineChecked);
        if (inWordIdDate) {
          formData.append(
            "inWordIdDate",
            moment(inWordIdDate).format("YYYY-MM-DD")
          );
        }
        if (inWordNumber) {
          formData.append("inWordNumber", inWordNumber);
        }
        if (appId) {
          formData.append("appId", appId);  
        }
        if (appIdDate) {
          formData.append("appIdDate", moment(appIdDate).format("YYYY-MM-DD"));
        }
        
        if(appIdFile) {
          formData.append("appIdFile", appIdFile);
        }
        if(inWordIdFile) {
          formData.append("inWordIdFile", inWordIdFile);
        } 
        if (physicalId === null && phyId === "") {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/create-physical`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("signIn")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (response.status === 201) {
            localStorage.setItem("physicalId", response.data.result.id);
            localStorage?.removeItem("physicalId");
            localStorage?.removeItem("projectId");
            localStorage?.removeItem("clientId");
            localStorage?.removeItem("OwnerId");
            localStorage?.removeItem("documentId");
            //navigate("/manage-project");
            toast.success('Application generated successfully.');

          }
        } else {
          const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/update-physical/${
              physicalId || phyId
            }`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("signIn")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.status === 200) {
            localStorage.setItem("physicalId", response.data.result.id);
            localStorage?.removeItem("physicalId");
            localStorage?.removeItem("projectId");
            localStorage?.removeItem("clientId");
            localStorage?.removeItem("OwnerId");
            localStorage?.removeItem("documentId");
            toast.success('Application updated successfully.');
            // navigate("/manage-project");
          }
        }
      } catch (error) {
        console.error("Error handling:", error);
        toast.error(error.response.data.message)
      }
    }
  };

  const handleEditData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-all-physical`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );

      const filteredDocuments = response.data.result.filter(
        (val) => val.projectId === (JSON.parse(projectId) || state?.projectId)
      );

      if (filteredDocuments.length > 0) {
        const record = filteredDocuments[filteredDocuments.length - 1];
        setPhyId(record.id);
        setPhysicalChecked(record?.physicalChecked);
        setInWordNumber(record?.inWordNumber);
        if (record?.inWordIdDate) {
          setInWordIdDate(new Date(record?.inWordIdDate));
      }
        // setInWordIdDate(new Date(record?.inWordIdDate));
        setInWordIdFile(record?.inWordIdFile);
        setOnlineChecked(record?.onlineChecked);
        setAppId(record?.appId);
        if (record?.appIdDate) {
          setAppIdDate(new Date(record?.appIdDate));
        }
        setAppIdFile(record?.appIdFile);
        setUserName(record?.userName);
        setPassword(record?.password);
        setEmail(record?.email);
        setEPassword(record?.ePassword)
      }
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    }
  };

  useEffect(() => {
    handleEditData();
  }, [state, projectId]);

  return (
    <>
      <div className="container card card-body">
        <div className="row justify-content-center">
          <form className="form-horizontal">
            <div className="form-group row">
              <div className="col-md-6">
                <div className="form-check mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={physicalChecked === 1}
                    onChange={(e) =>
                      setPhysicalChecked(e.target.checked ? 1 : 0)
                    }
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: "16px" }}
                  >
                    Physical
                  </label>
                </div>
                <div className="form-row">
                  <div className="form-group form-check col-md-12">
                    <label className="form-check-label">Inward number</label>
                    <input
                      type="number"
                      className={`form-control ${
                        errors.inWordNumber === "" && "is-invalid"
                      }`}
                      placeholder="Inward number"
                      value={inWordNumber}
                      onChange={(e) => {
                        setInWordNumber(e.target.value);
                        setErrors({ ...errors, inWordNumber: e.target.value });
                      }}
                    />
                    {errors.inWordNumber === "" && (
                      <div className="invalid-feedback">
                        Inward number is required
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group form-check col-md-12 d-flex">
                    <DatePicker
                      className={`form-control`}
                      selected={inWordIdDate || ""}
                      onChange={(date) => {
                        setInWordIdDate(date);
                      }}
                      showYearDropdown
                      showMonthDropdown
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group form-check col-md-12 d-flex">
                    <input
                      type="file"
                      className="form-control"
                      name="inWordIdFile"
                      onChange={(e) => setInWordIdFile(e.target.files[0])}
                    />
                    
                  </div>
                </div>
                {inWordIdFile && inWordIdFile !== null  && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('inWordIdFile')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {inWordIdFile instanceof Blob ? (
                                                            <a href={URL.createObjectURL(inWordIdFile)} target="_blank" rel="noopener noreferrer">
                                                                {inWordIdFile?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + inWordIdFile} target="_blank" rel="noopener noreferrer">
                                                                {inWordIdFile?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
              </div>
              <div className="col-md-6">
                <div className="form-check mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={onlineChecked === 1}
                    onChange={handleCheckboxChange}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: "16px" }}
                  >
                    Online
                  </label>
                </div>
                {onlineChecked === 1 && (
                  <>
                    <div className="form-row">
                      <label className="form-check-label">Username</label>
                      <div className="form-group form-check col-md-12">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.userName === "" && "is-invalid"
                          }`}
                          placeholder="Username"
                          value={userName}
                          onChange={(e) => {
                            setUserName(e.target.value);
                            setErrors({ ...errors, userName: e.target.value });
                          }}
                        />
                        {errors.userName === "" && (
                          <div className="invalid-feedback">
                            Username is required
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <label className="form-check-label">Password</label>
                      <div className="form-group form-check col-md-12 position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`form-control ${
                            errors.password === "" && "is-invalid"
                          }`}
                          placeholder="Password"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setErrors({
                              ...errors,
                              password: e.target.value,
                            });
                          }}
                        />
                        <div
                          className="position-absolute top-50 end-0 translate-middle-y"
                          style={{
                            cursor: "pointer",
                            marginRight: "17px",
                          }}
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <i className="bi bi-eye-slash"></i>
                          ) : (
                            <i className="bi bi-eye"></i>
                          )}
                        </div>
                        {errors.password === "" && (
                          <div className="invalid-feedback">
                            Password is required
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <label className="form-check-label">Email</label>
                      <div className="form-group form-check col-md-12">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.email === "" && "is-invalid"
                          }`}
                          placeholder="Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors({ ...errors, email: e.target.value });
                          }}
                        />
                        {errors.email === "" && (
                          <div className="invalid-feedback">
                            Email is required
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <label className="form-check-label">Email password</label>
                      <div className="form-group form-check col-md-12 position-relative">
                        <input
                          type={showEpassword ? "text" : "password"}
                          className={`form-control ${
                            errors.ePassword === "" && "is-invalid"
                          }`}
                          placeholder="Email password"
                          value={ePassword}
                          onChange={(e) => {
                            setEPassword(e.target.value);
                            setErrors({
                              ...errors,
                              ePassword: e.target.value,
                            });
                          }}
                        />
                        <div
                          className="position-absolute top-50 end-0 translate-middle-y"
                          style={{
                            cursor: "pointer",
                            marginRight: "17px",
                          }}
                          onClick={() => setShowEPassword(!showEpassword)}
                        >
                          {showEpassword ? (
                            <i className="bi bi-eye-slash"></i>
                          ) : (
                            <i className="bi bi-eye"></i>
                          )}
                        </div>
                        {errors.ePassword === "" && (
                          <div className="invalid-feedback">
                            Password is required
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <div className="form-row">
                  <label className="form-check-label">Application Id</label>
                  <div className="form-group form-check col-md-12">
                    <input
                      type="number"
                      className={`form-control ${
                        errors.appId === "" && "is-invalid"
                      }`}
                      placeholder="Application Id"
                      value={appId}
                      onChange={(e) => {
                        setAppId(e.target.value);
                        setErrors({ ...errors, appId: e.target.value });
                      }}
                    />
                    {errors.appId === "" && (
                      <div className="invalid-feedback">
                        Application id is required
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group form-check col-md-12 d-flex">
                    <DatePicker
                      className={`form-control`}
                      selected={appIdDate || ""}
                      onChange={(date) => {
                        setAppIdDate(date);
                      }}
                      showYearDropdown
                      showMonthDropdown
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group form-check col-md-12 d-flex">
                    <input
                      type="file"
                      className="form-control"
                      name="appIdFile"
                      onChange={(e) => setAppIdFile(e.target.files[0])}
                    />
                  </div>
                </div>
                {appIdFile && appIdFile !== null  && (
                                                    <>
                                                        <i
                                                            className="bi bi-trash3 float-right"
                                                            onClick={() => handleDeleteInvoice('appIdFile')}
                                                            style={{ cursor: 'pointer' }}>
                                                        </i>
                                                        {appIdFile instanceof Blob ? (
                                                            <a href={URL.createObjectURL(appIdFile)} target="_blank" rel="noopener noreferrer">
                                                                {appIdFile?.name}
                                                            </a>
                                                        ) : (
                                                            <a href={process.env.REACT_APP_BASE_URL + appIdFile} target="_blank" rel="noopener noreferrer">
                                                                {appIdFile?.split('/').pop().split('-').pop()}
                                                            </a>
                                                        )}
                                                    </>
                                                )}
              </div>
            </div>
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <div className="form-group text-center">
                <button
                  type="button"
                  style={{ border: "1px solid gray", marginRight: "10px" }}
                  className="btn btn-default btn res-btn-gray"
                  onClick={() => handleBack()}
                >
                  Previous
                </button>
                <button
                  type="button"
                  style={{ border: "1px solid gray" }}
                  className="btn btn-default col-xs-offset-1"
                  onClick={handleNext}
                >
                  Finish
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Application;
